/* eslint-ignore */
// @ts-nocheck
import React from "react";

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TootipTitle,
} from "./styles";

type CustomTooltipProps = {
  title: string;
  className?: string;
  children: React.ReactNode;
};

const CustomToolip: React.FC<CustomTooltipProps> = ({
  title,
  className,
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <TooltipContainer>
        <TootipTitle>{title}</TootipTitle>
        <TolltipItens>
          <ul>
            <li>
              Deve ter, no mínimo, <b> 8 caracteres</b>.
            </li>
            <li>
              Deve ter pelo menos <b>uma letra maiúscula</b>.
            </li>
            <li>
              Deve ter pelo menos <b>uma letra minúscula</b>.
            </li>
            <li>
              Deve ter pelo menos <b>um número</b>.
            </li>
            <li>
              Deve ter pelo menos <b>um caractere especial (!@#$)</b>.
            </li>
            <li>Não utilizar a última senha cadastrada.</li>
          </ul>
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default CustomToolip;
